import { createGlobalState } from 'react-use';

import { VisitSettlement } from '@dreryk/egabinet-financial-settlement-frontend-api';

type PrescriptionVisitSettlementGlobalStateMap = Map<number, VisitSettlement>;

const useGlobalState = createGlobalState<PrescriptionVisitSettlementGlobalStateMap>(new Map());

type UsePrescriptionVisitSettlementGlobalStateReturnFn = {
   getSettlement: (appointmentId: number) => VisitSettlement | null;
   updateSettlement: (state: PrescriptionVisitSettlementGlobalStateMap) => void;
   resetSettlement: VoidFunction;
};

export const usePrescriptionVisitSettlementGlobalState = (): UsePrescriptionVisitSettlementGlobalStateReturnFn => {
   const [globalState, setGlobalState] = useGlobalState();

   const getSettlement = (appointmentId: number): VisitSettlement | null => {
      return globalState.get(appointmentId) ?? null;
   };

   const resetSettlement = (): void => {
      setGlobalState(new Map());
   };

   return {
      getSettlement: getSettlement,
      updateSettlement: setGlobalState,
      resetSettlement: resetSettlement,
   };
};
